import { useEffect, useState } from 'react';

import { isNativePlatform } from '@/lib/capacitor';

/** Application installée (PWA en mode standalone) ou native (Capacitor). */
const useIsPWA = (): boolean => {
    const [isPWA, setIsPWA] = useState(() => isNativePlatform() || window.matchMedia('(display-mode: standalone)').matches);

    useEffect(() => {
        const mql = window.matchMedia('(display-mode: standalone)');
        const handler = (e: MediaQueryListEvent) => setIsPWA(e.matches || isNativePlatform());
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, []);

    return isPWA;
};

export default useIsPWA;
